export enum CoreEnum {
  // ==========================
  //            image
  // ==========================
  // sort
  ICON_SORT_DESC = 'icon-sort-desc',
  ICON_SORT_ASC = 'icon-sort-asc',
  // path
  IMG_PATH_SORT_ASC = '/icons/sorted.svg',
  IMG_PATH_SORT_DESC = '/icons/sorted.svg',
  IMG_PATH_SORT_NONE = '/icons/no-sort.svg',
  IMG_PATH_SENSITIVE_CLIENT = '/icons/sensitive.client.svg',
  IMG_PATH_CONTROL = '/icons/control.svg',
  IMG_PATH_INFO = '/icons/info.svg',
  IMG_PATH_LOCK = '/icons/lock.svg',
  IMG_PATH_WARNING = '/icons/warning.svg',
  IMG_PATH_UP_DOWN_ARROW = '/icons/up-down-arrow.svg',
  IMG_PATH_NOTE_EMPTY = '/icons/comment-add.svg',
  IMG_PATH_NOTE_NOT_EMPTY = '/icons/comment-fill.svg',
  IMG_PATH_UP = '/icons/up.svg',
  IMG_PATH_DOWN = '/icons/down.svg',
  IMG_PATH_EDIT = '/icons/edit.svg',
  IMG_PATH_PRESET_EDIT = '/icons/settings.svg',
  IMG_PATH_VALIDATE = '/icons/done.svg',
  IMG_PATH_REMOVE = '/icons/remove.svg',
  IMG_PATH_CANCEL = '/icons/close.svg',
  IMG_PATH_SPLIT = '/icons/cut.svg',
  IMG_PATH_SPLIT_ADD = '/icons/btn-add.svg',
  IMG_PATH_SPINNER = '/icons/spinner.svg',
  // css
  CLASS_OPERATION_TYPE_VER = 'bk-operation-VER',
  CLASS_OPERATION_TYPE_REF = 'bk-operation-REF',
  CLASS_OPERATION_TYPE_LMX = 'bk-operation-LMX',
  CLASS_OPERATION_TYPE_ACTIVE = 'bk-operation-active',
  CLASS_COIL_STATE_COMPLETED = 'bk-coil-state-COMPLETED',
  CLASS_COIL_STATE_PROGRAMMED = 'bk-coil-state-PROGRAMMED',
  CLASS_COIL_STATE_IN_PROGRESS = 'bk-coil-state-IN_PROGRESS',
  CLASS_COIL_STATE_IDENTIFIED = 'bk-coil-state-IDENTIFIED',
  CLASS_STOP_STATE_CREATED = 'bk-stop-state-CREATED',
  CLASS_STOP_STATE_IN_PROGRESS = 'bk-stop-state-IN_PROGRESS',
  CLASS_STOP_STATE_COMPLETED = 'bk-stop-state-COMPLETED',
  CLASS_BTN_FULLSCREEN = 'btn-fullscreen',
  CLASS_BTN_IMG = 'btn-img',
  CLASS_SPINNER_FOR_ROTATE = 'rotate-spinner',
  CLASS_MODAL = 'modal',
  CLASS_MODAL_NO_CLOSE_OUTSIDE = 'modal-no-close-outside',
  CLASS_NO_WIDTH = 'no-width',
  // text
  TEXT_YES = 'oui',
  TEXT_NO = 'non',
  TEXT_NA = 'N/A',
  TEXT_CHOICE = 'Choisir',
  // HEADERS
  HEADER_ROLE = 'role',

  // LOCAL STORAGE
  STATION_DETAIL = 'station-detail',
  ENDPOINT_ELECTRICITY = 'electrical',

  // STATION H20 URL OPC UA URL :
  OPCUA_URL_PREFIX = 'opc.tcp://',
  OPCUA_ACQUISITION_LOST_DELAY_DEFAULT = '900',

  // MAX SELECTED UNIT FOR TAGs
  MAX_UNITS = 10,

  // BADGES, SUBSCRIPTIONS
  DETAIL_BADGE = 'DETAIL_BADGE',
  DETAIL_SUBSCRIPTION = 'DETAIL_SUBSCRIPTION',
  ASSIGN_BADGE = 'ASSIGN_BADGE',
  UNASSIGN_BADGE = 'UNASSIGN_BADGE',
  ASSIGN_SUBSCRIPTION = 'ASSIGN_SUBSCRIPTION',
  USER_SUBSCRIPTION = 'USER_SUBSCRIPTION',
  VEHICLE_SUBSCRIPTION = 'VEHICLE_SUBSCRIPTION',

  // SEARCH MATCHING TYPE
  DEFAULT_MATCHING_TYPE = 'PARTIAL_MATCH_IGNORE_CASE'
}
